import { AnnouncementProps } from "@/interfaces/announcement_types";
import { AnnouncementCard } from "../Cards/AnnouncementCard";
import { SectionDiv } from "./Components/SectionDiv";

type AnnouncementSectionProps = {
    announcements: AnnouncementProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}

export function AnnouncementSection(
    { announcements, isNewCard, markAsSeen }: AnnouncementSectionProps
) {
    return (
        <SectionDiv className="mb-2" height="h-full">
            <h3 className="mb-3">Announcements:</h3>

            <div className="h-full pb-4 overflow-y-auto">
                {announcements.length > 0 ? announcements.reverse().map((announcement, index) => (
                    <AnnouncementCard
                        key={index}
                        announcement={announcement}
                        isNew={isNewCard('announcement', announcement.title ?? '')}
                        onView={() => markAsSeen('announcement', announcement.title ?? '')} />
                ))
                    :
                    <h3>No Announcements at the moment</h3>}
            </div>

        </SectionDiv>
    );
}
